import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const LEAD_CONTAINER_SIZE = {
  LARGE: 46,
  SMALL: 32,
} as const;

export const containerStyle = css`
  display: flex;
  overflow: hidden;
  width: ${LEAD_CONTAINER_SIZE.LARGE}px;
  padding: ${theme.spacing(0.25)};
`;
